import { StateCreator } from 'zustand';
import { DEFAULT_ENABLED_LOG_LEVELS, isLogLevel, LOG_LEVELS, LogLevel } from 'components/logViewer/logLevels.ts';

const STORAGE_KEY = 'logLevelFilter';

const sortByLevelOrder = (levels: LogLevel[]) => LOG_LEVELS.filter((level) => levels.includes(level));

const readEnabledLogLevels = (): LogLevel[] | undefined => {
  try {
    const item = localStorage.getItem(STORAGE_KEY);
    if (item === null) return undefined;

    const parsed: unknown = JSON.parse(item);

    return Array.isArray(parsed) ? sortByLevelOrder(parsed.filter(isLogLevel)) : undefined;
  } catch {
    return undefined;
  }
};

const writeEnabledLogLevels = (levels: LogLevel[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(levels));
  } catch {
    // ignore write errors
  }
};

type State = {
  enabledLogLevels: LogLevel[];
};

type Actions = {
  setEnabledLogLevels: (levels: LogLevel[]) => void;
};

export type LogLevelFilterSlice = State & Actions;

export const createLogLevelFilterSlice: StateCreator<
  LogLevelFilterSlice,
  [['zustand/immer', never]],
  [],
  LogLevelFilterSlice
> = (set) => ({
  enabledLogLevels: readEnabledLogLevels() ?? DEFAULT_ENABLED_LOG_LEVELS,
  setEnabledLogLevels: (levels: LogLevel[]) =>
    set((state) => {
      const nextLevels = sortByLevelOrder(levels);
      writeEnabledLogLevels(nextLevels);
      state.enabledLogLevels = nextLevels;
    }),
});
